var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.257 15.989a1.752 1.752 0 0 0-.846-2.326l-2.143-.999a1.749 1.749 0 0 0-2.325.847l-2.183 4.681c-.181.388-.213.83-.091 1.24l.831 2.783a.751.751 0 0 0 1.016.473l2.666-1.151a1.75 1.75 0 0 0 .892-.867zm-1.359-.634-2.183 4.681a.25.25 0 0 1-.128.124l-1.891.817-.59-1.974a.257.257 0 0 1 .013-.177l2.183-4.682a.252.252 0 0 1 .333-.12l2.142.998a.252.252 0 0 1 .121.333zM13.5 20.75H2.95a.197.197 0 0 1-.141-.059.197.197 0 0 1-.059-.141V19.1c0-.831.593-1.562 1.507-2.185C5.889 15.802 8.53 15.1 11.5 15.1c.83 0 1.634.055 2.399.16a.751.751 0 0 0 .202-1.487A19.299 19.299 0 0 0 11.5 13.6c-3.322 0-6.263.831-8.089 2.076-1.393.95-2.161 2.157-2.161 3.424v1.45a1.7 1.7 0 0 0 1.7 1.7H13.5a.75.75 0 0 0 0-1.5zM11.5 1.737a5.503 5.503 0 0 0-5.5 5.5c0 3.036 2.464 5.5 5.5 5.5s5.5-2.464 5.5-5.5c0-3.035-2.464-5.5-5.5-5.5zm0 1.5c2.208 0 4 1.793 4 4 0 2.208-1.792 4-4 4s-4-1.792-4-4c0-2.207 1.792-4 4-4z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profile-edit.de4c8f6d02707a9b83af5cd0125bf48a.svg";
export { ForwardRef as ReactComponent };